import { useAuthStore } from '@/stores/authStore';

/** React `key` for remounting sample grids when per-user persisted layout should reload. */
export function useSampleGridPersistScopeKey(): string {
  return useAuthStore((state) => {
    const user = state.currentUser;
    if (!user || user.isAnonymous) return 'anonymous';
    return `${user.id}:${user.usingSignInAs ? 'impersonate' : 'normal'}`;
  });
}
